import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import CustomerFeedback from './CustomerFeedback';

export default function Blog() {
  return (
    <>
        <Navbar />
        <CustomerFeedback />
        <Footer />
        <Copyright />
    </>
  )
}